  import { Component, OnInit } from '@angular/core';
  import { ActivatedRoute, Router } from '@angular/router';
  import { FirestoreService } from 'src/app/services/firestore.service';
  
  
  @Component({
    selector: 'app-handicraft-list',
    templateUrl: './handicraft-list.component.html',
    styleUrls: ['./handicraft-list.component.sass']
  })
  export class HandicraftListComponent implements OnInit {

    logoImage: string = "./assets/img/no-logo.png";
    coverImage: string = "./assets/img/cover-ads.png";

    handicraftCol;
    
    constructor(    
      private route: Router,
      private aroute: ActivatedRoute,
      public db: FirestoreService
    ) { }
  
    ngOnInit(): void {
      this.handicraftCol = this.db.getMainColWhere('storeproducts', 'category', 'Handicraft');
    };
  
    routeHandicraftDetailPage(docId){
      this.route.navigateByUrl('handicraft/'+docId);
    }
  
  }